<div class="ec-strategy-container">

    <!-- choose strategy -->
    <div fxLayout="column" fxLayoutAlign="center">
        <div fxLayoutAlign="center" class="txt-h-24-7 mb-30">{{ 'Choose a Strategy'|i18n }}
        </div>
        <div fxLayout="row">
            <div fxFlex="13"></div>
            <div fxLayout="row wrap" fxLayoutAlign="space-around" class="mt-42">
                <button *ngIf="availableStrategies.includes(STRATEGY_NEW_RULES)"
                        fxLayout="column" fxLayoutAlign="space-around center"
                        [fxFlex]="availableStrategies.length > 3 ? 40 : 31"
                        (click)="onSelectStrategy(STRATEGY_NEW_RULES)" class="strategy-button">
                    <app-icon name="fal-chart-pie" class="strategy-icon"></app-icon>
                    <div fxFlex="25" class="txt-h-18-7 mt-16">{{ STRATEGY_NEW_RULES|strategy|i18n }}</div>
                    <div fxFlex="50" class="txt-p-14-4 mt-16">
                        {{ 'Default strategy'|i18n }}
                    </div>
                </button>
                <button *ngIf="availableStrategies.includes(STRATEGY_OLD_CONDO)"
                        fxLayout="column" fxLayoutAlign="space-around center"
                        [fxFlex]="availableStrategies.length > 3 ? 40 : 31"
                        (click)="onSelectStrategy(STRATEGY_OLD_CONDO)" class="strategy-button">
                    <app-icon name="fal-bullseye-arrow" class="strategy-icon"></app-icon>
                    <div fxFlex="25" class="txt-h-18-7 mt-16">{{ STRATEGY_OLD_CONDO|strategy|i18n }}</div>
                    <div fxFlex="50" class="txt-p-14-4 mt-16">
                        {{ 'Configure fees and benefits (of owner members only) entirely by algorithm, based on energy sharing, self-consumption, and withdrawal.'|i18n }}
                    </div>
                </button>
                <button *ngIf="availableStrategies.includes(STRATEGY_NEW_CONDO)"
                        fxLayout="column" fxLayoutAlign="space-around center"
                        [fxFlex]="availableStrategies.length > 3 ? 40 : 31"
                        (click)="onSelectStrategy(STRATEGY_NEW_CONDO)" class="strategy-button">
                    <app-icon name="fal-bullseye-arrow" class="strategy-icon"></app-icon>
                    <div fxFlex="25" class="txt-h-18-7 mt-16">{{ STRATEGY_NEW_CONDO|strategy|i18n }}</div>
                    <div fxFlex="50" class="txt-p-14-4 mt-16">
                        {{ 'Configure fees and benefits (of owner and holder members) entirely by algorithm, based on energy sharing, self-consumption, and withdrawal.'|i18n }}
                    </div>
                </button>
            </div>
            <div fxFlex="13"></div>
        </div>
        <div fxLayoutAlign="center" class="mt-42">
            <button app-ghost-button (click)="onClickCancel()">
                {{ 'Cancel'|i18n }}
            </button>
        </div>
    </div>

</div>

